import React, {Component} from 'react'
import {Form} from 'semantic-ui-react'
import {getCompanyCollection} from '../firebase'

class Lista extends Component{
	constructor(props){
		super(props)
		this.filtro1=this.props.filtro1
		this.filtro2=this.props.filtro2
		this.filtro3=this.props.filtro3
		this.database = null
		this.excluir=Array.isArray(this.props.excluir) ? this.props.excluir : []
		this.incluir=Array.isArray(this.props.incluir) ? this.props.incluir : []
		this.state = {
			options: [],
		}
	}
	setReference=()=>{
        let dbReference=this.database
        dbReference=this.addFilter(dbReference)
        return dbReference
    }
	addFilter=dbReference=>{
        if(!this.filtro1 || !this.filtro2 || !this.filtro3) return dbReference
        return dbReference.where(this.filtro1, this.filtro2, this.filtro3)
    }
	childAdded=(querySnapshot)=>{
        const docs = []
		/*let count=0
		if(this.props.extraoptions){
			for(let i in this.props.extraoptions){
				docs.push(this.props.extraoptions[i])
			}
		}*/
		if(this.incluir){
			for(let i=0; i<this.incluir.length; i++){
				docs.push({key:i, value:this.incluir[i], text:this.incluir[i]})
			}
		}
		for(let i=0; i<querySnapshot.docs.length; i++){
			const doc=querySnapshot.docs[i]
			if(this.excluir.includes(doc.data()[this.props.columna])){
				continue
			}
            docs.push({key:doc.id, value:doc.data()[this.props.columna], text:doc.data()[this.props.columna]})
            //count++
		}
		this.setState({
			options:docs,
		})
	}
	async componentDidMount(){
		const collection = await getCompanyCollection(this.props.tabla)
		this.database = collection.orderBy(this.props.columna, 'asc')
		this.unsubscribe = this.setReference().onSnapshot(this.childAdded)
	}
	componentWillUnmount(){ if (this.unsubscribe) this.unsubscribe() }
	render(){
		//console.log(this.state.options)
		return (
		<div className='SelectContainer'>
			<Form.Dropdown 
				fluid
				selection
				search
				options={this.state.options}
				{...this.props}
			/>
		</div>
		)
	}
}

export default Lista;
